<template>
    <div data-cy="container_serial_staff_message">
        <div class="text-center text-yellow-500">
            <div class="py-4 text-12 text-a-red-ff4d4d" data-cy="text_serial_staff_message_line1" v-html="privilegeMsg"></div>
        </div>
        <div v-if="forStaff" class="border border-a-blue-2140a6 w-36 h-9 rounded-sm px-3 py-1.5 m-auto text-center">
            <button data-cy="btn_serial_for_staff" @click="clickForStaff()">
                <div class="size-text text-a-blue-2140a6 font-bold" data-cy="text_serial_staff_message_line2">{{lbl.serial.btn_for_staff}}</div>
            </button>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "PrivilegeMessage",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
        forStaff: Boolean
    },
    data: function() {
        return {
            privilegeMsg: "",
        };
    },
    created: function() {
        this.setPrivilegeMessage();
    },
    methods: {
        setPrivilegeMessage: function() {
            if (this.isSetPrivilege()) {
                if (this.forStaff) {
                    this.privilegeMsg = this.lbl.serial.title_for_staff;
                } else {
                   this.privilegeMsg = this.serialModel.privilegeMessage;
                }
            } else {
                this.privilegeMsg = this.lbl.serial.show_code_at_shop;
            }
        },
        isSetPrivilege: function() {
            if (Util.isEmptyStr(this.serialModel.privilegeMessage)) {
                return false;
            }

            if (this.serialModel.privilegeMessageFormat == "link") {
                return false;
            }

            return true;
        },
        clickForStaff: function() {
            this.$emit('clickStaff');
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
